import React from "react";
import PropTypes from "prop-types";

const ClearSelection = ({ items, refine, resetFilters, attr, label }) => (
  <button
    className="clear-selection"
    onClick={(e) => {
      if (refine) {
        if (!attr) {
          refine(items);
        } else {
          refine([items.find((i) => i.attribute === attr)]);
        }
      }

      if (resetFilters) {
        resetFilters(true);
      }
    }}
  >
    {label}
  </button>
);

ClearSelection.defaultProps = {
  label: "Clear",
};

ClearSelection.propTypes = {
  items: PropTypes.array,
  refine: PropTypes.func,
  resetFilters: PropTypes.func,
  attr: PropTypes.string,
  label: PropTypes.string,
};

export default ClearSelection;
